import { useCurrentStateAndParams, useRouter } from "@uirouter/react";
import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { timer } from "rxjs";
import { mapTo, take } from "rxjs/operators";
import { SidebarActions } from "../../store/sidebar/actions";
import { MenuNode } from "../menu";
import { useSidebarList } from "./context";

export function useSidebarNodes() {
  const router = useRouter();
  useCurrentStateAndParams();

  const sidebarList = useSidebarList();

  const sidebarListWithSelection = useMemo(() => {
    function augmentSelected(m: MenuNode.MenuNode): MenuNode.AugmentedNode {
      if (MenuNode.isParentNode(m)) {
        const newNode = {
          ...m,
          children: m.children.map((x) => augmentSelected(x)),
        };
        return {
          ...newNode,
          selected: !!newNode.children.find((y) => y.selected),
        };
      }
      return {
        ...m,
        selected: router.stateService.is(
          MenuNode.isLeafTargeted(m) ? m.target.state() : m.route
        ),
      };
    }

    return sidebarList.map((x) => augmentSelected(x));
  }, [sidebarList, router.globals.current]);

  return sidebarListWithSelection;
}

export function useRouteChange() {
  const dispatch = useDispatch();
  const router = useRouter();

  useEffect(() => {
    const unsub = router.transitionService.onBefore({}, () => {
      dispatch(SidebarActions.closeSidebar());
      return timer(150).pipe(take(1), mapTo(true)).toPromise();
    });
    return () => unsub();
  }, [router.transitionService]);
}
